module.exports = __webpack_public_path__ + "avenir-roman.3f3f84f74a0640b78a80.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/avenir/avenir-roman.woff2
// module id = ../../../../../src/assets/fonts/avenir/avenir-roman.woff2
// module chunks = styles